import { Validation } from "constants/Validation";
import * as Yup from "yup";
import { msgTypes } from "constants/msgTypes";

const ContactPersonSchema =
        Yup.object().shape({
                name: Yup.string().required(Validation.required.message.replaceAll("^", "Name"))
                        .matches(Validation.plaintext.regex, Validation.plaintext.message),
                position: Yup.string().required(Validation.required.message.replaceAll("^", "Designation"))
                        .matches(Validation.plaintext.regex, Validation.plaintext.message),
                phoneNumber: Yup.string().required(Validation.required.message.replaceAll("^", "Phone Number"))
                        .matches(Validation.mobile.regex, Validation.mobile.message),
                        // .min(10, Validation.minlength.message.replaceAll("^", 10))
                        // .max(15, Validation.maxlength.message.replaceAll("^", 15)),
                email: Yup.string().required(Validation.required.message.replaceAll("^", "Email-Id"))
                        .matches(Validation.email.regex, Validation.email.message),
                contactPersonImageFile: Yup.mixed().nullable()//.required(Validation.required.message.replaceAll("^","Image"))
                        .test(
                                "FILE_FORMAT",
                                msgTypes.IMAGE_UNSUPPORTED_FORMAT,
                                (value) => !value || (value && [msgTypes.IMAGE_FORMAT.JPEG, msgTypes.IMAGE_FORMAT.JPG, msgTypes.IMAGE_FORMAT.PNG
                                ].includes(value?.type))
                        )
                        .test(
                                "FILE_SIZE",
                                msgTypes.FILE_SIZE_MESSAGE_1MB,
                                (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_1MB)
                        ),
                contactIsrepresentative: Yup.boolean().required(Validation.required.message.replaceAll("^", "Representative")),
        })


export default ContactPersonSchema;